import {css} from 'styled-components';
import logoImg from './icons/clw/clw-logo.png';
import progress1 from './icons/clw/step-indicator-1.svg';
import progress2 from './icons/clw/step-indicator-2.svg';
import progress3 from './icons/clw/step-indicator-3.svg';

import progress1of2 from './icons/clw/step-indicator-1of2.svg';
import progress2of2 from './icons/clw/step-indicator-2of2.svg';

import whatsapp from './icons/sho/whatsapp.png';
import facebook from './icons/sho/facebook.svg';
import linkedin from './icons/sho/linkedin.svg';
import instagram from './icons/sho/instagram.svg';
import twitter from './icons/sho/x.svg';

const primary = '#0E4867';
// const lightGreen = '#01B22D';
const secondary = '#C72F3E';
// const secondaryHover = '#9b2432'
// const darkGreen = '#058221';
const darkRed = '#9B2432';
const lightBg = '#EFF3F5';
// const darkBg = '#00405B';
const lightText = '#FFFFFF';
const darkText = '#043148';
// const blueText = '#00405B';
// const redText = '#C72F3E';
const hover = '#FF7417AA';
const errorColor = '#9B2432';
const errorBg = '#fff9f9';
const black = '#000000';

let defaultFont = '"Fira Sans", "Arial", "sans-serif"';
let defaultFontHeavy = '"Veneer", "Fira Sans", "Arial", "sans-serif"';

export default {
  // GlobalStyles
  bodyFontFamily: defaultFont,
  h1FontFamily: defaultFontHeavy,
  h3FontFamily: defaultFontHeavy,
  h1FontSize: '21px',
  bodyFontSize: '16px',
  backgroundColor: lightBg,
  // AmountButton
  amountButton: {
    color: darkText,
    fontFamily: defaultFontHeavy,
    fontSize: '20px',
    width: '96px',
    height: '64px',
    border: `1px solid ${darkText}`,
    borderRadius: '12px',
    backgroundColor: lightText,
    borderActive: `1px solid ${darkText}`,
    borderHover: `1px solid ${darkText}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${darkText}`
  },
  buttonContainerSpaceBetween: {
    width: '96px'
  },
  //BackButton
  backButton: {
    fontSize: '16px',
    color: '#1A1A1A'
  },
  // Box
  boxComponent: {
    borderRadius: '12px',
    border: '0px'
  },
  // Button
  button: {
    borderRadius: '5px',
    fontFamily: defaultFontHeavy,
    fontSize: '20px',
    height: '56px',
    backgroundColor: secondary,
    color: '#fff',
    boxShadow: `0px 6px 0px 0px ${darkRed}`,
    active: css`
      background-color: ${primary};
      border-bottom: none;
      box-shadow: 0px 6px 0px 0px ${black} !important;
    `,
    hover: css`
      background-color: ${primary};
      box-shadow: 0px 6px 0px 0px ${black} !important;
    `,
    focus: css`
      box-shadow: 0px 6px 0px 0px ${darkRed} !important;
    `
  },
  // Checkbox
  inputCheckbox: {
    border: `1px solid ${black}`
  },
  box: {
    fontSize: '16px',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`,
    borderHover: '1px solid #818181',
    backgroundColorChecked: primary,
    backgroundBorderChecked: `1px solid ${black}`
  },
  // DateInput
  dateDropdown: {
    padding: '15.6px 30px 12.4px 10px',
    border: `1px solid ${black}`,
    borderRadius: '5px',
    boxShadowFocus: '0',
    borderFocus: `1px solid ${black}`,
    borderValid: `1px solid ${black}`,
    boxShadowError: '0',
    boxShadowValid: '0',
    backgroundColorValid: 'inherit',
    height: 'auto',
    chevronTop: '16px'
  },
  // DisplayIban
  iban: {
    fontFamily: defaultFont,
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '3px',
    backgroundColor: '#fff',
    fontSize: '18px',
    paddingLeft: '13px',
    border: `1px solid ${black}`,
    borderFocus: `1px solid ${black}`,
    boxShadowFocus: '0'
  },
  // ErrorMessage
  error: {
    backgroundColor: errorBg,
    color: errorColor,
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    fontSize: '16px',
    border: `1px solid ${black}`,
    borderFocus: `1px solid ${black}`,
    borderRadius: '3px',
    boxShadowFocus: 'none',
    colorPlaceholder: '#c4c4c4',
    borderValid: `1px solid ${black}`,
    boxShadowValid: 'none',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: errorBg
  },
  // TextArea
  textAreaComponent: {
    fontSize: '16px',
    border: '1px solid #c4c4c4',
    borderFocus: '1px solid #818181',
    boxShadowFocus: 'none',
    colorPlaceholder: '#c4c4c4',
    borderValid: `1px solid ${black}`,
    boxShadowValid: 'none',
    backgroundColorValid: '#F3FAF6',
    borderError: `1px solid ${errorColor}`,
    boxShadowError: 'none',
    colorError: errorColor,
    backgroundColorError: errorBg
  },
  // Label
  optionalLabel: {
    color: '#818181'
  },
  label: {
    fontSize: '16px',
    color: '#000',
    colorError: errorColor
  },
  logo: {
    width: '181px',
    height: '113px',
    backgroundImage: logoImg,
    widthMobile: '181px',
    heightMobile: '113px',
    margin: '0',
    marginMobile: '0'
  },
  // PaymentButton
  paymentButton: {
    color: secondary,
    fontFamily: defaultFont,
    fontSize: '16px',
    width: '115px',
    height: '78px',
    lineHeight: '78px',
    border: `1px solid ${black}`,
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: 'rgba(255,116,23,0.15)',
    borderHover: `2px solid ${secondary}`
  },
  // RadioButton
  inputRadioButton: {
    backgroundColor: '#fff',
    border: '1px solid #c4c4c4',
    backgroundColorActive: primary,
    borderActive: `1px solid ${black}`
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 40px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 40px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  radio: {
    borderHover: `1px solid ${hover}`,
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`
  },
  // TeaserHeader
  teaser: {
    display: 'inline',
    fontFamily: defaultFontHeavy,
    fontSize: '36px',
    fontWeight: 'bold',
    lineHeight: '47px',
    subtitleMarkerColor: lightText,
    color: primary,
    colorSubtitle: black,
    padding: '4px 8px',
    subtitleFontFamily: defaultFont,
    subtitleFontSize: '16px',
    subtitleLineHeight: '24px',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'left',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'left'
  },
  // Title
  title: {
    color: '#fff',
    fontFamily: defaultFontHeavy,
    fontSize: '21px',
    height: '65px',
    fontWeight: 'normal',
    borderRadius: '8px',
    backgroundColor: primary
  },
  // Validation
  validation: {
    color: errorColor,
    fontSize: '15px'
  },
  // OptIn
  optInButton: {
    fontFamily: defaultFont,
    fontSize: '20px',
    backgroundColor: '#000',
    color: black,
    boxShadow: 'none',
    active: css`
      background-color: #000;
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: #000;
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: '#000',
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  }
};


